import script from "./TextSnippetChildrenForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TextSnippetChildrenForm.vue?vue&type=script&setup=true&lang=js"

import "./TextSnippetChildrenForm.vue?vue&type=style&index=0&id=469e4926&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-469e4926"]])

export default __exports__